import { useQuery } from '@apollo/client'
import { GET_ALL_FILTERS } from 'query/query'
import { useSelector } from 'react-redux'
import { selectUserSubscription } from 'reducers/subscription/selectors'
import { RootState } from 'reducers/store'

export const useFilters = (filterSchema: string) => {
  const context = useSelector((state: RootState) => selectUserSubscription(state))
  const { data, loading } = useQuery(GET_ALL_FILTERS, {
    variables: {
      schema: filterSchema,
      context,
    },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-first',
  })
  return { data, loading }
}
